import { Box, CloseIcon, SxProps } from '@modusign/design-system';
import { ButtonHTMLAttributes } from 'react';

interface XButtonProps extends SxProps, ButtonHTMLAttributes<HTMLButtonElement> {
  size: number;
}

const defaultProps = {
  size: 14,
};

function XButton({ size, ...props }: XButtonProps) {
  return (
    <Box as="button" type="button" {...props}>
      <CloseIcon
        color="darkGray50"
        height={size}
        sx={{
          pointerEvents: 'none',
          '&:hover': {
            color: 'darkGray200',
          },
        }}
        width={size}
      />
    </Box>
  );
}

XButton.defaultProps = defaultProps;

export default XButton;
